<template>
    <div class="container-fluid">
        <div v-if="user" class="row">
            <!-- <div class="col-md-12">
                <div v-if="createdDevices">
                    <CreatedDevicesLineChart :createdDevicesByDays="createdDevices"></CreatedDevicesLineChart>
                </div>
                <LoadingAnimation v-else></LoadingAnimation>
            </div> -->
            <div class="col-md-4">
                <div v-if="openOrders">
                    <OpenOrders :openOrders="openOrders"></OpenOrders>
                </div>
                <LoadingAnimation v-else></LoadingAnimation>
            </div>
            <div class="col-md-4">
                <div v-if="devices">
                    <LastDevices :latestDevices="devices"></LastDevices>
                </div>
                <LoadingAnimation v-else></LoadingAnimation>
            </div>
            <div class="col-md-4">
                <div v-if="completedOrders">
                    <InvoiceTable :invoices="completedOrders"></InvoiceTable>
                </div>
                <LoadingAnimation v-else></LoadingAnimation>
            </div>
            <div class="col-md-6 offset-md-3">
                <div v-if="warranties">
                    <DeviceWarranties :deviceWarranties="warranties"></DeviceWarranties>
                </div>
                <LoadingAnimation v-else></LoadingAnimation>
            </div>
        </div>
    </div>
</template>

<script>
    import LoadingAnimation from '@/components/general/LoadingAnimation.vue'
    import LastDevices from '@/components/dashboard/LastDevices.vue'
    import OpenOrders from '@/components/dashboard/OpenOrders.vue'
    import DeviceWarranties from '@/components/dashboard/DeviceWarranties.vue';
    import CreatedDevicesLineChart from '@/components/dashboard/CreatedDevicesLineChart.vue';
    import InvoiceTable from '@/components/dashboard/InvoiceTable.vue';
    import Mgr from '@/services/SecurityService'
    import ApiService from '@/services/ApiService.js';
    import Moment from 'moment'

    let apiService = new ApiService();
    let moment = new Moment();

    let currentDate = new Date();
    currentDate = moment.utc(currentDate).format();

    let within30Minutes = moment.add(30, "minutes")
    within30Minutes = moment.utc(within30Minutes).format();

    let withIn30Days = moment.subtract(30, "days");
    withIn30Days = moment.utc(withIn30Days).local().format();

    let withinOneHour = moment.add(60, "minutes").format();
    let endOfDay = moment.utc().endOf('day').format();

    export default {
        components: {
            LastDevices,
            OpenOrders,
            DeviceWarranties,
            CreatedDevicesLineChart,
            InvoiceTable,
            LoadingAnimation
        },
        data() {
            return {
                mgr: new Mgr(),
                user: null,
                devices: null,
                openOrders: null,
                completedOrders: null,
                warranties: null,
                createdDevices: null,
                number: 90,
                storedOrg: JSON.parse(localStorage.getItem("org")),
            };
        },
        methods: {
            // storage key, org, api endpoint
            // check local storage for cached data
            // look for stored org
            // pull data from API
            getDevices() {
                if (this.user) {
                    // create api endpoint
                    let apiEndpoint
                    if (this.storedOrg !== null) {
                        if (this.storedOrg.includes('#')) {
                            this.storedOrg = this.storedOrg.replace("#", "%23")
                        }
                        apiEndpoint = `/odata/datagriddevices?%24orderby=Created%20desc&%24top=15&%24filter=(contains(tolower(OrganizationName)%2c%27${this.storedOrg}%27))%20and%20(Created%20ge%20${withIn30Days})&%24count=true`
                    }
                    else {
                        apiEndpoint = `/odata/datagriddevices?%24filter=Created%20ge%20${withIn30Days}&%24count=true&%24top=15&%24orderby=Created%20desc`
                    }
                    // trigger API call
                    this.getData("devices", apiEndpoint, this.getDevicesCallback)
                }
            },
            getDevicesCallback(result, setLocalStorage) {
                if (!setLocalStorage) {
                    this.devices = result;
                }
                // set local storage
               else if (setLocalStorage) {
                    this.devices = result.value;
                    localStorage.setItem("devices", JSON.stringify({ name: this.user.profile.name, value: this.devices, expireDate: within30Minutes }));
                }
            },
            getOpenOrders() {
                if (this.user) {
                    // create api endpoint
                    let apiEndpoint;
                    if (this.storedOrg !== null) {
                        if (this.storedOrg.includes('#')) {
                            this.storedOrg = this.storedOrg.replace("#", "%23")
                        }
                        apiEndpoint = `/odata/datagridsopdocuments?%24filter=contains(tolower(OrganizationName)%2C%27${this.storedOrg}%27)%20and%20_sopType%20eq%202&%24count=true&%24top=200&%24orderby=Created%20desc`
                    }
                    else {
                        apiEndpoint = `/odata/datagridsopdocuments?%24filter=_sopType%20eq%202&%24top=200&%24orderby=Created%20desc`
                    }
                    // trigger API call
                    this.getData("openOrders", apiEndpoint, this.getOpenOrdersCallback)
                }
            },
            getOpenOrdersCallback(result, setLocalStorage) {
                if (!setLocalStorage) {
                    this.openOrders = result
                }
                // set local storage
                else if (setLocalStorage) {
                    this.openOrders = result.value;
                    localStorage.setItem("openOrders", JSON.stringify({ name: this.user.profile.name, value: this.openOrders, expireDate: within30Minutes }));
                }
            },
            getCompletedOrders() {
                if (this.user) {
                    // create api endpoint
                    let apiEndpoint;
                    if (this.storedOrg !== null) {
                        if (this.storedOrg.includes('#')) {
                            this.storedOrg = this.storedOrg.replace("#", "%23")
                        }
                        apiEndpoint = `/odata/datagridsopdocuments?%24filter=contains(tolower(OrganizationName)%2C%20%27${this.storedOrg}%27)%20and%20(_sopType%20eq%2033)%20and%20(InvoiceDate%20ge%20${withIn30Days})&%24count=true&%24top=20&%24orderby=Created%20desc`
                    }
                    else {
                        apiEndpoint = `/odata/datagridsopdocuments?%24filter=(_sopType%20eq%2033)%20and%20(InvoiceDate%20ge%20${withIn30Days})&%24count=true&%24top=20&%24orderby=Created%20desc`
                    }
                    // trigger API call
                    this.getData("completedOrders", apiEndpoint, this.getCompletedOrdersCallback)
                }
            },
            getCompletedOrdersCallback(result, setLocalStorage) {
                if (!setLocalStorage) {
                    this.completedOrders = result;
                }
                // set local storage
                else if (setLocalStorage) {
                    this.completedOrders = result.value;
                    localStorage.setItem("completedOrders", JSON.stringify({ name: this.user.profile.name, value: this.completedOrders, expireDate: within30Minutes }));
                }
            },
            getCachedWarranties() {
                if (this.user) {
                    // create api endpoint
                    let apiEndpoint;

                    apiEndpoint = `/dice/dashboard/getWarrantyInfo/${this.storedOrg}`

                    // trigger API call
                    this.getData("warranties", apiEndpoint, this.getCachedWarrantiesCallback)

                }
            },
            getCachedWarrantiesCallback(result, setLocalStorage) {
                if (!setLocalStorage) {
                    this.warranties = result;
                }
                // set local storage
                else if (setLocalStorage) {
                    this.warranties = result;
                    localStorage.setItem("warranties", JSON.stringify({ name: this.user.profile.name, value: this.warranties, expireDate: within30Minutes }));
                }
            },
            getCachedCreatedDevices() {
                if (this.user) {
                    // create api endpoint
                    let apiEndpoint;

                    apiEndpoint = `/dice/dashboard/getCreatedDevicesByDays/${this.storedOrg}/ ` + this.number

                    // trigger API call
                    this.getData("createdDevices", apiEndpoint, this.getCachedCreatedDevicesCallback)

                }
            },
            getCachedCreatedDevicesCallback(result, setLocalStorage) {
                if (!setLocalStorage) {
                    this.createdDevices = result;
                }
                // set local storage
                else if (setLocalStorage) {
                    this.createdDevices = result;
                    localStorage.setItem("createdDevices", JSON.stringify({ name: this.user.profile.name, value: this.createdDevices, expireDate: within30Minutes }));

                }
            },
            //generic
            getData(storageKey, apiEndpoint, _callback) {
                // check local storage for cached data
                let storedData = localStorage.getItem(storageKey)
                if (storedData !== null) {
                    let data = JSON.parse(storedData)
                    //data.expireDate = moment.utc(data.expireDate).format()
                    // check if data is expired or if user is not the same
                    if (data.expireDate > currentDate && this.user.profile.name === data.name && data.value !== undefined) {
                        // callback to pull from local storage but don't reset expire
                        _callback(data.value, false);
                    } else {
                        apiService.get(process.env.VUE_APP_DICE_URI + apiEndpoint).then(
                            success => {
                                if (success) {
                                    let response = success
                                    // callback to set API response and local storage
                                    _callback(response, true);
                                }
                            }, err => {
                                console.log(err)
                                return null;
                            })
                    }
                } else {
                    // if data didn't exist or was expired, pull from API
                    apiService.get(process.env.VUE_APP_DICE_URI + apiEndpoint).then(
                        success => {
                            if (success) {
                                let response = success
                                // callback to set API response and local storage
                                _callback(response, true);
                            }
                        }, err => {
                            console.log(err)
                            return null;
                        })
                }
            }
        },
        created() {
            this.mgr.getUser().then(
                data => {
                    this.user = data;

                    this.getCompletedOrders();
                    this.getOpenOrders();
                    this.getDevices();
                    this.getCachedWarranties();
                    this.getCachedCreatedDevices();
                },
                err => {
                    console.log(err)
                }
            );
        }
    }
</script>

<style>
</style>
